import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FiHome, FiArrowLeft, FiSearch, FiHelpCircle, FiMail } from 'react-icons/fi';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-muted/20 flex items-center justify-center p-4">
      <div className="w-full max-w-2xl text-center space-y-8">
        {/* 404 Illustration */}
        <div className="relative">
          <div className="text-[9rem] sm:text-[12rem] font-bold text-primary/10 leading-none select-none">
            404
          </div>

          <div className="absolute inset-0 flex items-center justify-center">
            <div className="p-8 bg-card rounded-full border shadow-lg">
              <FiSearch className="w-16 h-16 text-muted-foreground" />
            </div>
          </div>
        </div>

        {/* Error Message */}
        <div className="space-y-4">
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">Page Not Found</h1>

          <p className="text-base sm:text-xl text-muted-foreground max-w-md mx-auto">
            Sorry, we couldn't find the page you're looking for. The page may have been moved,
            deleted, or the URL might be incorrect.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => navigate(-1)}
            className="w-full sm:w-auto inline-flex items-center border rounded  px-2 py-1"
          >
            <FiArrowLeft className="w-4 h-4 mr-2" />
            Go Back
          </button>

          <button className="w-full sm:w-auto inline-flex border rounded bg-primary text-white px-2 py-1">
            <Link to="/" className="inline-flex items-center">
              <FiHome className="w-4 h-4 mr-2" />
              Home
            </Link>
          </button>
        </div>

        {/* Help Section */}
        <div className="pt-6 border-t">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-muted-foreground">
            <div className="flex items-center gap-2">
              <FiHelpCircle className="w-4 h-4" />
              <span>Need help? Check our</span>

              <Link to="/support" className="text-primary hover:underline">
                Support Center
              </Link>
            </div>

            <div className="flex items-center gap-2">
              <FiMail className="w-4 h-4" />
              <span>Or</span>

              <Link to="/contact" className="text-primary hover:underline">
                Contact Us
              </Link>
            </div>
          </div>
        </div>

        {/* Dev Info */}
        {import.meta.env.NODE_ENV === 'development' && (
          <div className="mt-8 bg-muted/30 border border-dashed rounded-lg p-4">
            <p className="text-xs text-muted-foreground font-mono">
              Dev Info: Current URL — {window.location.pathname}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
